import React, { useState } from 'react';
import { MessageSquareIcon, UsersIcon, SearchIcon, PlusIcon } from 'lucide-react';
const Community = () => {
  const [activeTab, setActiveTab] = useState('preguntas');
  return <div className="bg-gray-50 py-12" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="text-center mb-12" data-id="element-110">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-111">Comunidad</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-112">
            Conecta con otros jugadores, comparte experiencias y encuentra
            respuestas a tus preguntas
          </p>
        </div>
        {/* Tabs de navegación */}
        <div className="bg-white rounded-t-xl shadow-sm" data-id="element-113">
          <div className="border-b border-gray-200" data-id="element-114">
            <nav className="flex -mb-px" data-id="element-115">
              <button onClick={() => setActiveTab('preguntas')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm flex items-center ${activeTab === 'preguntas' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-116">
                <MessageSquareIcon className="h-5 w-5 mr-2" data-id="element-117" />
                Preguntas y Respuestas
              </button>
              <button onClick={() => setActiveTab('participantes')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm flex items-center ${activeTab === 'participantes' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-118">
                <UsersIcon className="h-5 w-5 mr-2" data-id="element-119" />
                Conectar con Participantes
              </button>
            </nav>
          </div>
        </div>
        {activeTab === 'preguntas' && <QuestionsTab data-id="element-120" />}
        {activeTab === 'participantes' && <ParticipantsTab data-id="element-121" />}
      </div>
    </div>;
};
const QuestionsTab = () => {
  // Preguntas de ejemplo
  const questions = [{
    id: 1,
    title: '¿Cómo puedo adaptar el juego para jugarlo solo?',
    author: 'Carlos G.',
    date: 'hace 2 días',
    category: 'Reglas del juego',
    answers: 3,
    views: 45
  }, {
    id: 2,
    title: 'Tengo dudas sobre la planificación financiera en el retiro',
    author: 'María L.',
    date: 'hace 5 días',
    category: 'Finanzas',
    answers: 7,
    views: 112
  }, {
    id: 3,
    title: '¿Alguien ha probado el modo "Hijo Cuidador"? Necesito consejos',
    author: 'Roberto S.',
    date: 'hace 1 semana',
    category: 'Experiencias',
    answers: 4,
    views: 89
  }, {
    id: 4,
    title: 'Recursos recomendados sobre vivienda colaborativa',
    author: 'Ana P.',
    date: 'hace 2 semanas',
    category: 'Vivienda',
    answers: 6,
    views: 103
  }, {
    id: 5,
    title: '¿Cómo organizar un grupo para jugar en mi comunidad?',
    author: 'Javier M.',
    date: 'hace 3 semanas',
    category: 'Organización',
    answers: 5,
    views: 78
  }];
  return <div className="bg-white rounded-b-xl shadow-sm p-6" data-id="element-122">
      {/* Barra de búsqueda y filtros */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8" data-id="element-123">
        <div className="w-full md:w-1/2 relative" data-id="element-124">
          <input type="text" placeholder="Buscar preguntas..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" data-id="element-125" />
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-126" />
        </div>
        <div className="flex items-center space-x-4 w-full md:w-auto" data-id="element-127">
          <select className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm" data-id="element-128">
            <option data-id="element-129">Todas las categorías</option>
            <option data-id="element-130">Reglas del juego</option>
            <option data-id="element-131">Finanzas</option>
            <option data-id="element-132">Experiencias</option>
            <option data-id="element-133">Vivienda</option>
            <option data-id="element-134">Organización</option>
          </select>
          <button className="bg-blue-600 text-white hover:bg-blue-700 px-4 py-2 rounded-lg text-sm font-medium flex items-center" data-id="element-135">
            <PlusIcon className="h-4 w-4 mr-1" data-id="element-136" />
            Nueva pregunta
          </button>
        </div>
      </div>
      {/* Lista de preguntas */}
      <div className="space-y-4" data-id="element-137">
        {questions.map(question => <div key={question.id} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50" data-id="element-138">
            <div className="flex flex-col md:flex-row justify-between" data-id="element-139">
              <div data-id="element-140">
                <h3 className="text-lg font-medium text-blue-600 hover:text-blue-800 mb-2" data-id="element-141">
                  <a href="#" data-id="element-142">{question.title}</a>
                </h3>
                <div className="flex items-center text-sm text-gray-500" data-id="element-143">
                  <span data-id="element-144">Por {question.author}</span>
                  <span className="mx-2" data-id="element-145">•</span>
                  <span data-id="element-146">{question.date}</span>
                  <span className="mx-2" data-id="element-147">•</span>
                  <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs" data-id="element-148">
                    {question.category}
                  </span>
                </div>
              </div>
              <div className="flex items-center space-x-4 mt-3 md:mt-0" data-id="element-149">
                <div className="text-center" data-id="element-150">
                  <div className="text-lg font-semibold text-gray-900" data-id="element-151">
                    {question.answers}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-152">Respuestas</div>
                </div>
                <div className="text-center" data-id="element-153">
                  <div className="text-lg font-semibold text-gray-900" data-id="element-154">
                    {question.views}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-155">Vistas</div>
                </div>
              </div>
            </div>
          </div>)}
      </div>
      {/* Paginación */}
      <div className="mt-8 flex justify-center" data-id="element-156">
        <nav className="flex items-center space-x-2" data-id="element-157">
          <a href="#" className="px-3 py-1 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50" data-id="element-158">
            Anterior
          </a>
          <a href="#" className="px-3 py-1 rounded-md bg-blue-50 border border-blue-500 text-blue-600" data-id="element-159">
            1
          </a>
          <a href="#" className="px-3 py-1 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50" data-id="element-160">
            2
          </a>
          <a href="#" className="px-3 py-1 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50" data-id="element-161">
            3
          </a>
          <span className="px-2 text-gray-500" data-id="element-162">...</span>
          <a href="#" className="px-3 py-1 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50" data-id="element-163">
            8
          </a>
          <a href="#" className="px-3 py-1 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50" data-id="element-164">
            Siguiente
          </a>
        </nav>
      </div>
    </div>;
};
const ParticipantsTab = () => {
  // Participantes de ejemplo
  const participants = [{
    id: 1,
    name: 'Elena Martínez',
    location: 'Madrid, España',
    interests: ['Mentalidad y Propósito', 'Salud y Bienestar'],
    bio: 'Profesora jubilada interesada en el voluntariado y la escritura. Busco conectar con personas que estén explorando nuevas formas de vivir el retiro.',
    joinDate: 'Miembro desde mayo 2023'
  }, {
    id: 2,
    name: 'Miguel Ángel Ruiz',
    location: 'Barcelona, España',
    interests: ['Finanzas y Futuro', 'Vivienda y Comunidad'],
    bio: 'Arquitecto retirado con interés en cohousing y comunidades intergeneracionales. Me encanta compartir ideas sobre cómo diseñar espacios para el bienestar.',
    joinDate: 'Miembro desde junio 2023'
  }, {
    id: 3,
    name: 'Laura Gómez',
    location: 'Valencia, España',
    interests: ['Conexión y Legado', 'Salud y Bienestar'],
    bio: 'Entusiasta del envejecimiento activo y la tecnología. Organizo grupos de juego en mi comunidad y me interesa el impacto social.',
    joinDate: 'Miembro desde abril 2023'
  }, {
    id: 4,
    name: 'Javier Moreno',
    location: 'Sevilla, España',
    interests: ['Mentalidad y Propósito', 'Finanzas y Futuro'],
    bio: 'Emprendedor senior que inició un proyecto después de jubilarme. Me gusta compartir mi experiencia y aprender de otros en situaciones similares.',
    joinDate: 'Miembro desde julio 2023'
  }, {
    id: 5,
    name: 'Carmen Rodríguez',
    location: 'Bilbao, España',
    interests: ['Vivienda y Comunidad', 'Conexión y Legado'],
    bio: 'Psicóloga especializada en transiciones vitales. Facilito grupos de juego y talleres sobre planificación del retiro con propósito.',
    joinDate: 'Miembro desde marzo 2023'
  }, {
    id: 6,
    name: 'Antonio Fernández',
    location: 'Málaga, España',
    interests: ['Salud y Bienestar', 'Finanzas y Futuro'],
    bio: 'Médico jubilado interesado en el bienestar integral. Busco compartir conocimientos sobre hábitos saludables para un retiro pleno.',
    joinDate: 'Miembro desde agosto 2023'
  }];
  return <div className="bg-white rounded-b-xl shadow-sm p-6" data-id="element-165">
      {/* Barra de búsqueda y filtros */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8" data-id="element-166">
        <div className="w-full md:w-1/2 relative" data-id="element-167">
          <input type="text" placeholder="Buscar participantes..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" data-id="element-168" />
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-169" />
        </div>
        <div className="flex items-center space-x-4 w-full md:w-auto" data-id="element-170">
          <select className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm" data-id="element-171">
            <option data-id="element-172">Todos los intereses</option>
            <option data-id="element-173">Mentalidad y Propósito</option>
            <option data-id="element-174">Vivienda y Comunidad</option>
            <option data-id="element-175">Finanzas y Futuro</option>
            <option data-id="element-176">Salud y Bienestar</option>
            <option data-id="element-177">Conexión y Legado</option>
          </select>
          <select className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm" data-id="element-178">
            <option data-id="element-179">Todas las ubicaciones</option>
            <option data-id="element-180">Madrid</option>
            <option data-id="element-181">Barcelona</option>
            <option data-id="element-182">Valencia</option>
            <option data-id="element-183">Sevilla</option>
            <option data-id="element-184">Bilbao</option>
          </select>
        </div>
      </div>
      {/* Lista de participantes */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-185">
        {participants.map(participant => <div key={participant.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-186">
            <div className="flex items-center mb-4" data-id="element-187">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-semibold text-xl mr-4" data-id="element-188">
                {participant.name.charAt(0)}
              </div>
              <div data-id="element-189">
                <h3 className="font-semibold text-gray-900" data-id="element-190">
                  {participant.name}
                </h3>
                <p className="text-sm text-gray-500" data-id="element-191">{participant.location}</p>
              </div>
            </div>
            <p className="text-gray-700 mb-4 text-sm" data-id="element-192">{participant.bio}</p>
            <div className="mb-4" data-id="element-193">
              <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-194">
                INTERESES
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-195">
                {participant.interests.map((interest, index) => <span key={index} className="bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded" data-id="element-196">
                    {interest}
                  </span>)}
              </div>
            </div>
            <div className="flex justify-between items-center" data-id="element-197">
              <span className="text-xs text-gray-500" data-id="element-198">
                {participant.joinDate}
              </span>
              <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-199">
                Conectar
              </button>
            </div>
          </div>)}
      </div>
      {/* Grupos de interés */}
      <div className="mt-12" data-id="element-200">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-201">
          Grupos de interés
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-202">
          <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-203">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-204">
              Vivienda Colaborativa
            </h3>
            <p className="text-gray-700 text-sm mb-4" data-id="element-205">
              Grupo para explorar modelos de cohousing y comunidades
              intergeneracionales.
            </p>
            <div className="flex justify-between items-center" data-id="element-206">
              <span className="text-sm text-gray-500" data-id="element-207">42 miembros</span>
              <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-208">
                Unirse
              </button>
            </div>
          </div>
          <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-209">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-210">
              Emprendimiento Senior
            </h3>
            <p className="text-gray-700 text-sm mb-4" data-id="element-211">
              Para quienes quieren iniciar proyectos o negocios en su etapa de
              retiro.
            </p>
            <div className="flex justify-between items-center" data-id="element-212">
              <span className="text-sm text-gray-500" data-id="element-213">28 miembros</span>
              <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-214">
                Unirse
              </button>
            </div>
          </div>
          <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-215">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-216">
              Bienestar Integral
            </h3>
            <p className="text-gray-700 text-sm mb-4" data-id="element-217">
              Compartimos recursos y experiencias sobre salud física, mental y
              emocional.
            </p>
            <div className="flex justify-between items-center" data-id="element-218">
              <span className="text-sm text-gray-500" data-id="element-219">56 miembros</span>
              <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-220">
                Unirse
              </button>
            </div>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-221">
          <button className="text-blue-600 hover:text-blue-800 font-medium flex items-center mx-auto" data-id="element-222">
            <PlusIcon className="h-4 w-4 mr-1" data-id="element-223" />
            Crear un nuevo grupo
          </button>
        </div>
      </div>
    </div>;
};
export default Community;